<template>
  <component v-bind:is="layout"></component>
</template>

<script>
import Admin from '@/layout/Admin.vue'
import Loading from '@/layout/Loading'
import Blank from '@/layout/Blank'
import ConsultaBoletoExterno from '@/views/consultaBoletoExterno/ConsultaBoletoExterno.vue'

export default {
  name: 'App',
  computed: {
    layout () {
      return this.$store.getters.getLayout
    }
  },
  components: {
    'admin': Admin,
    'loading': Loading,
    'blank': Blank,
    'consulta-boleto' : ConsultaBoletoExterno
  }
}
</script>
<style lang='scss'>
@import "@/assets/scss/style.scss";
</style>
